import { render, staticRenderFns } from "./ColorList.vue?vue&type=template&id=4fe38e84&"
import script from "./ColorList.vue?vue&type=script&lang=js&"
export * from "./ColorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports